import React, { Fragment, FC, useContext } from 'react';
import './load-summary.scss';
import { Trip, TripSummary } from 'services/types'
import { TripContext } from 'contexts';

type Props = {
    loadId: number
}

export const LoadSummary: FC<Props> = ({ loadId }) => {

    const tripContext = useContext(TripContext)
    const load: Trip = tripContext.trips.find(t => t.id === loadId) ?? {} as Trip
    const summary: TripSummary = load.summary
    const na = ''

    return (
        <Fragment>
            <div className="load-summary-row">
                <div className="load-summary-horizontal"></div>
                <div className="load-summary-horizontal">Delivery</div>
                <div className="load-summary-horizontal">PickUp</div>
                <div className="load-summary-horizontal">Return</div>
            </div>
            <div className="load-summary-row">
                <div className="load-summary-heading">Count</div>
                <div className="load-summary-content">{summary.deliveryCount ?? na}</div>
                <div className="load-summary-content">{summary.pickupCount ?? na}</div>
                <div className="load-summary-content">{summary.returnCount ?? na}</div>
            </div>
            <div className="load-summary-row">
                <div className="load-summary-heading">Lbs</div>
                <div className="load-summary-content">{summary.deliveryWeight ?? na}</div>
                <div className="load-summary-content">{summary.pickupWeight ?? na}</div>
                <div className="load-summary-content">{summary.returnWeight ?? na}</div>
            </div>
            <div className="load-summary-row">
                <div className="load-summary-heading">Items</div>
                <div className="load-summary-content">{summary.deliveryLineItems ?? na}</div>
                <div className="load-summary-content">{summary.pickupItems ?? na}</div>
                <div className="load-summary-content">{summary.returnItems ?? na}</div>
            </div>
            <div className="load-summary-row">
                <div className="load-summary-heading">Pieces</div>
                <div className="load-summary-content">{summary.deliveryPieces ?? na}</div>
                <div className="load-summary-content">{summary.pickupPieces ?? na}</div>
                <div className="load-summary-content">{summary.returnPieces ?? na}</div>
            </div>
        </Fragment>
    );
}